export const AppConfig = {
  site_name: "Cimigo Consumer Project",
  title: "Cimigo Consumer Project",
  description: "Cimigo Consumer Project in NextJS",
  locale: "en",
};

export enum ECODE {
  USER_ALREADY_IN_ORGANIZATION = 1,
  USER_UNAUTHORIZED = 2,
  USER_NOT_FOUND = 3,
}
export function detectDevice(ua: string) {
  const isMobile = /mobile|android|iphone|ipad|phone/i.test(ua);
  // You can add more device detection logic here if needed
  return isMobile;
}

export enum TYPE_PAGE {
  DETAIL = 1,
  DETAIL_SHARE = 2,
  INTERACTIVE_SHARE = 3,
}

export enum MODE_REPORT {
  POWERBI = "powerbi",
  PDF = "pdf",
  EMBED = "embed",
}
